// Confirm-through generation friction, proportional to unreviewed work —
// never a hard block, and manual adds are never gated. Thresholds are UI
// constants by design (commercial caps are metered elsewhere).
export const GENERATION_THRESHOLDS = { assumptions: 20, findings: 30 } as const;

// Propose-then-promote surfaces (synthesis, capabilities): re-generating
// replaces the proposal, so any pending proposal is unreviewed debt.
export function pendingProposalFriction(pendingCount: number): number | null {
  return pendingCount > 0 ? pendingCount : null;
}

// Direct-write surfaces (assumptions, market findings): friction only once
// the list is big enough that more generation buries it.
export function thresholdFriction(existingCount: number, threshold: number): number | null {
  return existingCount >= threshold ? existingCount : null;
}
